/** @format */

export default {
	SET_REPORTS_FEES: 'SET_REPORTS_FEES',
	SET_ERROR_FOR_REPORTS_FEES: 'SET_ERROR_FOR_REPORTS_FEES',
	SET_REPORTS_FEES_SUMMARY: 'SET_REPORTS_FEES_SUMMARY',
	SET_ERROR_FOR_REPORTS_FEES_SUMMARY: 'SET_ERROR_FOR_REPORTS_FEES_SUMMARY',
	SET_REPORTS_BALANCE_SUMMARY: 'SET_REPORTS_BALANCE_SUMMARY',
	SET_ERROR_FOR_REPORTS_BALANCE_SUMMARY:
		'SET_ERROR_FOR_REPORTS_BALANCE_SUMMARY',
};
